import React from 'react';
import { Link } from 'react-router';
import { logOrThrowError } from "../../utility/logging";

/**
 * Every page on Ashland has a corresponding "broker" version with a /broker url.
 * I.e., for the url /xxxx, there will also be /broker/xxxx. This may be a bad
 * idea (duplicate content issues come to mind), but it's how it was set up how
 * I got here and the urls are still (presumably) being used for something, so
 * we have to keep them. The tricky part, which this component addresses, is
 * that: on the broker version's of each page, all the links needs to go to other
 * broker urls, whereas that same page rendered at its non-broker url should have
 * all its links rendered without `/broker/`. This component renders a link, but
 * first determines whether it should be a broker-version link, by looking at the
 * url of the current page.
 */
const component = ({to, ...props}) => {
  if(typeof to == 'string' && to.charAt(0) !== '/') {
    logOrThrowError(new Error(`Link's to prop should be a root-relative url (i.e. starting with /); was: ${to}.`));
  }

  switch(typeof to) {
    case 'undefined':
      return <Link {...props} />

    case 'string':
      return <Link {...props} to={(location) => {
        return location && location.pathname && location.pathname.indexOf('/broker/') === 0
          ? '/broker' + to
          : to;
      }} />;

    case 'function':
      throw new Error("Using a function for the to prop is not yet supported.");

    default:
      throw new Error(`${to} is an invalid value for the "to" property.`);
  }
};

component.displayName = "Link";
export default component;



// WEBPACK FOOTER //
// ./client/components/Link/index.js